var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  fillRule: "evenodd",
  d: "M.876.146 6 5.27 11.124.146a.5.5 0 0 1 .706 0l.024.024a.5.5 0 0 1 0 .706L6.73 6l5.124 5.124a.5.5 0 0 1 0 .706l-.024.024a.5.5 0 0 1-.707 0L6 6.73.876 11.854a.5.5 0 0 1-.706 0l-.024-.024a.5.5 0 0 1 0-.707L5.27 6 .146.876a.5.5 0 0 1 0-.706L.17.146a.5.5 0 0 1 .706 0",
  clipRule: "evenodd"
})));
export default SvgClose;